import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { PrimaryButton } from "components/Buttons";
import { ClientFeedbackForm } from "components/Client";
import { useAuth } from "hooks";

/**
 * ClientFeedbackAddButton
 */
const ClientFeedbackAddButton = (props) => {
  const [showForm, setShowForm] = useState(false);
  const { isAdmin } = useAuth();

  if (!isAdmin) return null;

  return (
    <>
      <PrimaryButton onClick={() => setShowForm(true)}>
        <FormattedMessage id={`Client.ClientFeedbackAddButton.Button`} />
      </PrimaryButton>
      <ClientFeedbackForm
        show={showForm}
        onClose={() => setShowForm(false)}
        isEditing={false}
        {...props}
      />
    </>
  );
};

export default ClientFeedbackAddButton;
